import request from '@/utils/request'

// 查询设备信息列表分页
export function fetchList(query) {
    return request({
        url: '/fix/dev/page',
        method: 'get',
        params: query,
    })
}
// 查询设备信息列表不分页
export function devList(query) {
    return request({
        url: '/fix/dev/list',
        method: 'get',
        params: query,
    })
}
// 查询设备详细
export function getObj(id) {
    return request({
        url: '/fix/dev/detail?id=' + id,
        method: 'get',
    })
}
// 新增设备
export function addObj(data) {
    return request({
        url: '/fix/dev/add',
        method: 'post',
        data: data,
    })
}
// 修改设备
export function putObj(data) {
    return request({
        url: '/fix/dev/edit',
        method: 'post',
        data: data,
    })
}
// 删除设备
export function delObj(data) {
    return request({
        url: '/fix/dev/delete',
        method: 'post',
        data: data,
    })
}
